module.exports = __webpack_public_path__ + "img/icon-paperclip.f564901c.svg";